module.exports = __webpack_public_path__ + "public/img/3.5e6be2f6.png";